/**
 * QR Codes Module Configuration
 *
 * Provides dynamic QR code management — create, update, organize, and
 * track scan analytics for QR codes whose destination URLs can be changed
 * at any time without reprinting.
 *
 * Access: admin and member roles only.
 * Public redirect views are registered separately (see routes.ts publicRoutes).
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const qrCodesModule: AppModule = {
    id: 'qr-codes',

    navigation: {
        label: 'QR Codes',
        icon: 'qr-code',
        path: '/qr-codes',
        order: 75,
        moduleKey: 'qr_codes',


        pages: [
            {
                label: 'All QR Codes',
                path: '/qr-codes',
                icon: 'qr-code',
            },
            {
                label: 'Add QR Code',
                path: '/qr-codes/create',
                icon: 'plus',
            },
            {
                label: 'Analytics',
                path: '/qr-codes/analytics',
                icon: 'bar-chart-3',
            },
        ],
    },

    routes,
}

export default qrCodesModule
